import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import pdf from "../../Assets/Sameer Misbah.pdf";

function Resume() {
  const uri = "https://porfolio-backend.vercel.app/ranks/getRanks";
  // const [spojRank, upadteSpojRank] = useState(0);
  // const [hackerrank, upadteHackerank] = useState(0);
  // const [sem, upadateSem] = useState(0);
  // const [cgpa, upadteCgpa] = useState(0);

  useEffect(() => {
    axios
      .get(uri)
      .then((res) => {
        // upadteSpojRank(res.data.message[0].spojRank);
        // upadteHackerank(res.data.message[1].hackerrank);
        // upadteCgpa(res.data.message[2].cgpa);
        // upadateSem(res.data.message[3].sem);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank" disabled>
            <i className="fas fa-download">&nbsp;</i>Download
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Software Engineer at Wavetec"
              date="April 01, 2021 — Present"
              content={[
                "Currently working on Wavetec's in-house ERP software.",
                "Our ERP includes most of the SAPs functionality with some additional features top on it.",
                "Some of the technologies that I have been working on includes (ReactJS/Redux/JQuery/BootStrap/CoreUI) for front-end and (Laravel/MySQL) for the back-end."
              ]}
            />
            <Resumecontent
              title="Instructor at Aptech SFC"
              date="January 15, 2020 — 20 Feb, 2021"
              content={[
                "Taught multiple courses like Android, Laravel, PHP, Bootstrap, JQuery, JavaScript, Angular, IOS, Software Engineering, Java EE.",
                "Supervised and helped in developing different projects.",
                "Conducted various workshops on different topics.",
                "Helped in organizing many events."
              ]}
            />
            <Resumecontent
              title="Internee at Pakish Hosting"
              date="June 17, 2019 — Sep 20, 2019"
              content={[
                "Developed multiple websites using WordPress/.NET and used cPanel for hosting. Worked with Avada Theme, Elementor page builder and different types of Plugins.",
                "Analyzed and identified how responsive websites are made using bootstrap.",
                "Learned about WooCommerce plugin for designing ecommerce websites.",
                "Learned the basics of jQuery and AJAX.",
              ]}
            />
            <Resumecontent
              title="Internee at Interns Pakistan"
              date="July 15, 2018 — Sep 10, 2018"
              content={[
                "Did six weeks of Internship at Interns Pakistan which included working with HTML, CSS, JavaScript, PHP, ASP.NET and Wordpress.",
                "After the internship worked on a side project with Interns Pakistan which required developing a C-Language chat-bot using ASP.NET and MySQL.",
              ]}
            />
            <Resumecontent
              title="Junior Web Developer at ACM Community"
              date="Sep 19, 2017 — Nov 25, 2017"
              content={[
                "Worked as a back-end web developer.",
              ]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="BS.(CS) from DHA Suffa University"
              date="2016 — 2020"
              content={[`CGPA: 3.34`]}
            />
            <Resumecontent
              title="H.S.C from Govt College For Mens"
              date="2013 — 2015"
              content={["Precentage: 69%"]}
            />
            <Resumecontent
              title="S.S.C From The Educators School"
              date="2011 - 2013"
              content={["Precentage: 78%"]}
            />
            <h3 className="resume-title">Ranks and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                "Obtained 3.65 SGPA in second semester.",
                "Obtained 3.50 SGPA in eighth semester.",
                "Obtained 3.44 SGPA in seventh semester.",
                "Got merit Scholarship for getting 3rd position in my batch.",
                "Runners Up of Speed Debugging at Spectrum 2018.",
                "Scored third position in Speed Debugging at Developers Day 2018.",
                "Qualified for the final round of speed debugging at Spectrum 2017.",
                "Qualified for the top 5 at Cross Code 2017.",
               ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank" disabled>
            <i className="fas fa-download">&nbsp;</i>Download
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
